import { render, staticRenderFns } from "./AreaMap.vue?vue&type=template&id=37ccbe48&scoped=true"
import script from "./AreaMap.vue?vue&type=script&lang=js"
export * from "./AreaMap.vue?vue&type=script&lang=js"
import style0 from "./AreaMap.vue?vue&type=style&index=0&id=37ccbe48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ccbe48",
  null
  
)

export default component.exports